import React from 'react';
import { DatePicker, TextButton, FilledButton } from '@ds/react-components';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { ReactComponent as FilterIcon } from 'assets/icons/ic-filter.svg';

const styles = (theme) => ({
  filterButton: {
    height: '42px',
    width: '98px',
    whiteSpace: 'nowrap',
  },
  filterIcon: {
    fontSize: '14px',
    marginRight: '8px',
  },
  clearButton: {
    height: '42px',
    width: '85px',
    color: theme.palette.xpl.text.primary,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: '500',
    textDecoration: 'none',
  },
  datePicker: {
    width: '100%',
  },
  containerGrid: {
    padding: '20px 8px 8px 25px',
    flexGrow: 1,
  },
  buttonsGrid: {
    marginTop: '25px',
    [theme.breakpoints.down('md')]: {
      marginTop: '8px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
});

const Filter = (props) => {
  const {
    classes,
    handleStartDateChange,
    startDate,
    startDateHelperText,
    handleEndDateChange,
    endDate,
    localisation,
    endDateHelperText,
    handleFilterClick,
    handleClearClick,
  } = props;

  const { dateFormat } = localisation.locales;

  return (
    <Grid container spacing={1} className={classes.containerGrid}>
      <Grid item md={6} lg={2} xs={12}>
        <DatePicker
          label="From"
          onChange={handleStartDateChange}
          value={startDate}
          format={dateFormat}
          placeholder={dateFormat}
          error={startDateHelperText}
          labelId={'fromDate'}
          variant="dialog"
          classes={{
            datePicker: classes.datePicker,
          }}
          okLabel={''}
          cancelLabel={''}
        />
      </Grid>
      <Grid item md={6} lg={2} xs={12}>
        <DatePicker
          label="To"
          onChange={handleEndDateChange}
          value={endDate}
          format={dateFormat}
          placeholder={dateFormat}
          error={endDateHelperText}
          labelId={'endDate'}
          variant="dialog"
          classes={{
            datePicker: classes.datePicker,
          }}
          okLabel={''}
          cancelLabel={''}
        />
      </Grid>
      <Grid item md={12} lg={8} xs={12} className={classes.buttonsGrid}>
        <TextButton
          variant="text"
          onClick={handleClearClick}
          className={classes.clearButton}>
          Clear
        </TextButton>
        <FilledButton
          variant="primary"
          className={classes.filterButton}
          onClick={handleFilterClick}>
          <>
            <FilterIcon className={classes.filterIcon} />
            {'Filter'}
          </>
        </FilledButton>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(Filter);
